import { render, staticRenderFns } from "./CocoClub.vue?vue&type=template&id=796f3792&scoped=true"
import script from "./CocoClub.vue?vue&type=script&lang=js"
export * from "./CocoClub.vue?vue&type=script&lang=js"
import style0 from "./CocoClub.vue?vue&type=style&index=0&id=796f3792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796f3792",
  null
  
)

export default component.exports